module.exports = __webpack_public_path__ + "img/full_logo.d505998b.png";